import styled, { keyframes } from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../common/formInputsV2/styles/tokens';

const driftSlow = keyframes`
  from { transform: translateX(-2.5%); }
  to { transform: translateX(2.5%); }
`;

const driftFast = keyframes`
  from { transform: translateX(2%); }
  to { transform: translateX(-2%); }
`;

const cardIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const LoginPageStyles = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px 16px;
  overflow: hidden;
  font-family: ${v2FontFamily};
  background: linear-gradient(180deg, #f4fafc 0%, #eaf6f1 100%);

  /* Layered waves pinned to the bottom. The SVG is wider than the viewport so
     the slow horizontal drift never exposes an edge. */
  .login-waves {
    position: absolute;
    left: -5%;
    bottom: 0;
    width: 110%;
    height: clamp(220px, 42vh, 460px);
    pointer-events: none;
  }

  .login-wave-back {
    animation: ${driftSlow} 14s ease-in-out infinite alternate;
  }

  .login-wave-mid {
    animation: ${driftFast} 11s ease-in-out infinite alternate;
  }

  @media (prefers-reduced-motion: reduce) {
    .login-wave-back,
    .login-wave-mid,
    .login-card {
      animation: none;
    }
  }

  .login-card {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 420px;
    padding: 36px 36px 30px;
    background: #fff;
    border: 1px solid rgba(16, 24, 40, 0.06);
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(16, 24, 40, 0.04), 0 18px 48px rgba(16, 24, 40, 0.12);
    animation: ${cardIn} 420ms ease-out both;

    @media (max-width: ${v2Breakpoints.tablet}) {
      padding: 30px 22px 24px;
    }
  }

  .login-logo {
    display: flex;
    justify-content: center;

    img {
      width: 170px;
      height: auto;
    }
  }

  .login-title {
    margin: 22px 0 4px;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
    text-align: center;
    color: ${v2Colors.text};
  }

  .login-subtitle {
    margin: 0 0 18px;
    font-size: 14px;
    text-align: center;
    color: ${v2Colors.textMuted};
  }

  .login-error {
    margin: 0 0 14px;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 600;
    color: ${v2Colors.danger};
    background: ${v2Colors.dangerSoft};
    border: 1px solid ${v2Colors.dangerBorder};
    border-radius: 12px;
  }

  .login-success {
    margin: 0 0 14px;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 600;
    color: ${v2Colors.primaryHover};
    background: ${v2Colors.primarySoft};
    border: 1px solid ${v2Colors.primaryBorder};
    border-radius: 12px;
  }

  .login-group + .login-group {
    margin-top: 14px;
  }

  .login-field {
    position: relative;
  }

  .login-field-icon {
    position: absolute;
    top: 11px;
    left: 14px;
    width: 18px;
    height: 18px;
    color: ${v2Colors.textFaint};
    pointer-events: none;
    transition: color 120ms ease;
  }

  .login-field:focus-within .login-field-icon {
    color: ${v2Colors.borderStrong};
  }

  .login-field .form-control {
    padding-left: 42px;
  }

  .login-submit {
    margin-top: 18px;
  }

  /* Keeps the same height as the button while loading, so the card doesn't
     jump when the label swaps. */
  .login-submit button {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .login-forgot {
    margin: 18px 0 0;
    text-align: center;
    font-size: 14px;

    a {
      color: ${v2Colors.textMuted};
      font-weight: 600;
      transition: color 150ms ease;
    }

    a:hover {
      color: ${v2Colors.primaryHover};
      text-decoration: underline;
    }
  }
`;

export default LoginPageStyles;
